import { render } from "./MatchReportView.vue?vue&type=template&id=36935a42&scoped=true"
import script from "./MatchReportView.vue?vue&type=script&lang=js"
export * from "./MatchReportView.vue?vue&type=script&lang=js"

import "./MatchReportView.vue?vue&type=style&index=0&id=36935a42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36935a42"]])

export default __exports__